import { render, staticRenderFns } from "./AddQualificationApproval.vue?vue&type=template&id=70559986&scoped=true"
import script from "./AddQualificationApproval.vue?vue&type=script&lang=js"
export * from "./AddQualificationApproval.vue?vue&type=script&lang=js"
import style0 from "./AddQualificationApproval.vue?vue&type=style&index=0&id=70559986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70559986",
  null
  
)

export default component.exports